/** プレビュー読み込み中に表示する、テキスト行を模したスケルトンローダー。 */
function SkeletonBar({ width }: { width: string }) {
	return (
		<div
			style={{
				width,
				height: 12,
				borderRadius: "var(--radius-2)",
				background:
					"linear-gradient(90deg, var(--skeleton-base) 0%, var(--skeleton-highlight) 50%, var(--skeleton-base) 100%)",
				backgroundSize: "200% 100%",
				animation: "izanagi-skeleton-shimmer 1.4s ease-in-out infinite",
			}}
		/>
	);
}

const LINE_WIDTHS = ["70%", "90%", "55%", "80%", "40%", "85%", "60%"];

export function PreviewSkeleton() {
	return (
		<div
			data-testid="preview-skeleton"
			style={{
				display: "flex",
				flexDirection: "column",
				gap: 10,
				padding: 16,
			}}
		>
			{LINE_WIDTHS.map((width, i) => (
				<SkeletonBar key={i} width={width} />
			))}
		</div>
	);
}
